import {css} from "reakit";
import colors from "./colors";

export default {
	basic: {
		border: '1px solid  #EBEBEB'
	},
	pinned: {
		// border: `1px solid ${colors.gray}`,
		// padding: '1%'
		// width: '322px',
		minHeight: '92px',
		maxHeight: '92px',
		border: '1px solid #ffffff',
		borderRadius: '5px',
		boxShadow: '0 0 6px rgba(0, 0, 0, .16)'
	},
	leavesFilter: css`
      background-color: #2b80b9;
      border-radius: 12.975px;
      box-shadow: inset 0 2px 6px rgba(0, 0, 0, .16);
      width: 49px;
      height: 26px;
      overflow: hidden;
      font-size: 9.5px;
      font-weight: 300;
      color: #ffffff;
      `,
	post: {
		// borderBottom: `1px solid ${colors.bgLight}`,
		// width: '45%',
		// minHeight: '123px',
		// maxHeight: '6em'

	},
	approve: {
		// minHeight: '50vh'
	},
	roster: {
		// borderBottom: `1px solid ${colors.bgLight}`,
		// width: '45%',
		minHeight: '50px',
		maxHeight: '50px'

	},
	chat: {
		// borderBottom: `1px solid ${colors.bgLight}`,
		// width: '45%',
		minHeight: '70px',
		maxHeight: '70px'

	},
	buttonBar: {
		zIndex: 99999
	},
	user: {
		//
		// minHeight:
	},
	leaves: {
		paddingBottom: '10px',
		borderBottom: `1px solid ${colors.bgLight}`,


	},
	leaveBar: {
		fontWeight: '600'

	},
	chatMessage: {
		borderRadius: '5px',
		boxShadow: '0 0 6px rgba(0, 0, 0, .16)',
		width: '80%'
	}
}